































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import AccountDepositCardSettings from '@/models/Accounts/DepositAccounts/Settings/AccountDepositCardSettings';
// import AccountDepositCardSettingsEditDialog from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/Cards/AccountDepositCardSettingsEditDialog.vue';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'AccountDepositCardSettingsRead', components: { } }) // AccountDepositCardSettingsEditDialog
export default class extends SaascadaVueFieldGroup {

    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: AccountDepositCardSettings;

}
